import React from 'react'
import PropTypes from 'prop-types'

import { FieldError, FieldHint } from 'components/FormElements'
import { FilePickerControl } from 'components/Controls'
import classNames from 'classnames'

export const FilePickerField = ({
  meta = {},
  translateParams,
  className = 'mb-3',
  hintText,
  ...props
}) => {
  const { error } = meta

  const showError = Boolean(error)

  return (
    <>
      <div
        className={classNames({
          [className]: className,
        })}
      >
        <div
          className={classNames('', {
            'is-invalid': showError,
          })}
        >
          <FilePickerControl {...props} />
        </div>

        {hintText && <FieldHint message={hintText} />}

        <FieldError error={error} translateParams={translateParams} showError={showError} />
      </div>
    </>
  )
}

FilePickerField.propTypes = {
  translateParams: PropTypes.object,
  meta: PropTypes.object,
  className: PropTypes.string,
  hintText: PropTypes.string,
}
